

export enum ScoreType {
	PROGRESS = 0,
	PLACEMENT = 1,
}
export namespace ScoreHelper {
	export function isLastYearStudentScore(student: any, questionId: number) : boolean {
		if (student.previousScores[questionId]?.score && !student?.scores[questionId]) {
			return true;
		} else {
			return false;
		}

	}
}